// Licensed under Gnu Public License version 2
// Copyright (c) 2024 (original work) Open Assessment Technologies SA ;

export default {
    mySessions: '/certification/my-sessions'
};
